import React from "react";

import { Box, CircularProgress, Typography, Backdrop } from "@mui/material";

interface LoadingOverlayProps {
  open: boolean;
  message?: string;
  size?: number;
}

export const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ open, message = "Loading...", size = 40 }) => {
  return (
    <Backdrop
      sx={{
        color: "#fff",
        zIndex: (theme) => theme.zIndex.drawer + 1,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
      }}
      open={open}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 2,
        }}
      >
        <CircularProgress color="inherit" size={size} />
        <Typography variant="h6" component="div">
          {message}
        </Typography>
      </Box>
    </Backdrop>
  );
};
